import { useEntity } from '@backstage/plugin-catalog-react';
import { PdsAlert, PdsLink } from '@principal/design-system-react';

export function AccountDeleteInProgressCard() {
  const { entity } = useEntity();
  const accountDeleteIssueUrl =
    entity.spec?.account_delete_issue_url?.toString();

  return (
    <>
      {accountDeleteIssueUrl && (
        <>
          <div
            style={{
              color: '#222222',
            }}
          >
            <PdsAlert variant="warning">
              A request to delete this account has been submitted. Nagivate to{' '}
              <PdsLink variant="strong" href={accountDeleteIssueUrl}>
                the GitHub Issue
              </PdsLink>{' '}
              for updates.
            </PdsAlert>
          </div>
          <br />
        </>
      )}
    </>
  );
}
